import React from 'react';

function SkeletonBlock({ className = '' }) {
  return <div className={`animate-pulse rounded-lg bg-slate-700/50 ${className}`} />;
}

export default function LoadingSkeleton({ type = 'text', count = 3 }) {
  if (type === 'card') {
    return (
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {Array.from({ length: Math.max(count, 4) }).slice(0, 4).map((_, index) => (
          <div
            key={`card-skeleton-${index}`}
            className="rounded-xl border border-slate-700 bg-slate-800/80 p-5"
          >
            <SkeletonBlock className="mb-4 h-12 w-12 rounded-full" />
            <SkeletonBlock className="mb-3 h-4 w-24" />
            <SkeletonBlock className="mb-2 h-9 w-28" />
            <SkeletonBlock className="h-3 w-32" />
          </div>
        ))}
      </div>
    );
  }

  if (type === 'table') {
    return (
      <div className="overflow-hidden rounded-xl border border-slate-700 bg-slate-800">
        <div className="grid grid-cols-4 gap-4 border-b border-slate-700 bg-slate-900 px-4 py-3">
          {Array.from({ length: 4 }).map((_, index) => (
            <SkeletonBlock key={`table-head-${index}`} className="h-3 w-20 rounded-md" />
          ))}
        </div>
        <div className="divide-y divide-slate-700">
          {Array.from({ length: 5 }).map((_, rowIndex) => (
            <div key={`table-row-${rowIndex}`} className="grid grid-cols-4 gap-4 px-4 py-4">
              <SkeletonBlock className="h-4 w-20" />
              <SkeletonBlock className="h-4 w-24" />
              <SkeletonBlock className="h-4 w-28" />
              <SkeletonBlock className="h-4 w-16" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (type === 'chart') {
    return (
      <div className="rounded-xl border border-slate-700 bg-slate-800 p-4">
        <SkeletonBlock className="mb-4 h-4 w-36" />
        <SkeletonBlock className="h-[300px] w-full rounded-xl" />
      </div>
    );
  }

  const widths = ['w-full', 'w-5/6', 'w-3/4', 'w-11/12', 'w-2/3'];

  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonBlock
          key={`text-skeleton-${index}`}
          className={`h-4 ${widths[index % widths.length]}`}
        />
      ))}
    </div>
  );
}
